"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropArea = void 0;
var react_1 = __importDefault(require("react"));
exports.DropArea = function (_a) {
    var _b = _a.accept, accept = _b === void 0 ? "*" : _b, _c = _a.multiple, multiple = _c === void 0 ? true : _c, _d = _a.dropOnPage, dropOnPage = _d === void 0 ? false : _d, _e = _a.customValidator, customValidator = _e === void 0 ? function () { return true; } : _e, _f = _a.onDrop, onDrop = _f === void 0 ? function () { } : _f, _g = _a.onDropAccepted, onDropAccepted = _g === void 0 ? function () { } : _g, children = _a.children;
    return (react_1.default.createElement(react_1.default.Fragment, null));
};
